<template>
  <div
    class="ll-display-button-bar"
    :class="{mw200:mw200}"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "LlDisplayButtonBar",
  props: {
    mw200: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-display-button-bar";
</style>